// Enlace externo
const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL;
const API_HOST = process.env.REACT_APP_API_ENDPOINT_PROD;
const API_PORT = process.env.REACT_APP_API_PORT;

const URL_API_Externa = `${API_PROTOCOL}://${API_HOST}:${API_PORT}`;

// Enlace interno
const URL_API_InternaPermisos = process.env.REACT_APP_API_PERMISOS;
const URL_API_InternaCarga = process.env.REACT_APP_API_CARGAS;
const URL_API_InternaParametros = process.env.REACT_APP_API_PARAMETROS;

export const API_ENDPOINTS = {
  externa: {
    authenticate: `${URL_API_Externa}/api/v1/authenticate`,
    user: (userId) => `${URL_API_Externa}/api/v1/users/${userId}`,
    autocomplete: (address) => `${URL_API_Externa}/api/ghost/v2/autocomplete?companyID=1&text=${encodeURIComponent(address)}`,
    autocompleteplaceid: (placeID) => `${URL_API_Externa}/api/ghost/v2/autocomplete/details?placeID=${placeID}`,
    bookings: `${URL_API_Externa}/api/v1/bookings`,
    drivers: `${URL_API_Externa}/api/ghost/v1/drivers`,
    vehicles: `${URL_API_Externa}/api/v1/vehicles`,
    bookingscomplete: `${URL_API_Externa}/api/ghost/v1/accounts/dockets`,
  },
  interna: {
    // Api Permisos Usuarios
    validate_user: `${URL_API_InternaPermisos}/?action=validate_user`,
    get_user_menus: (username) => `${URL_API_InternaPermisos}/?action=get_user_menus&username=${username}`,

    // Api CargaMasiva
    SelectDataSettingHualpen: `${URL_API_InternaCarga}/?action=SelectDataSetting&visible=1`,
    SelectDataSettingBcoChile: `${URL_API_InternaCarga}/?action=SelectDataSetting&visible=3`,
    InsertDataCarga: `${URL_API_InternaCarga}/?action=InsertDataCarga`,
    CreateServicesGhostAPI: (id) => `${URL_API_InternaCarga}/?action=CreateServicesGhostAPI&id=${id}`,
    LiberaProcesoCarga: (cargaId) => `${URL_API_InternaCarga}/?action=LiberaProcesoCarga&idCarga=${cargaId}`,

    // Api Respuestas de Cargas
    RespuestaGhost: `${URL_API_InternaCarga}/?action=RespuestaDataGhost`,

    // Api Parametros
    //-- Clientes
    SelectAllDataClient: `${URL_API_InternaParametros}/?action=SelectAllDataClient`,
    InsertDataClient: `${URL_API_InternaParametros}/?action=InsertDataClient`,
    UpdateDataClient: `${URL_API_InternaParametros}/?action=UpdateDataClient`,
    DeleteDataClient: `${URL_API_InternaParametros}/?action=DeleteDataClient`,
    //-- Tarifas
    SelectAllDataTarifa: `${URL_API_InternaParametros}/?action=SelectAllDataTarifa`,
    InsertDataTarifa: `${URL_API_InternaParametros}/?action=InsertDataTarifa`,
    UpdateDataTarifa: `${URL_API_InternaParametros}/?action=UpdateDataTarifa`,
    DeleteDataTarifa: `${URL_API_InternaParametros}/?action=DeleteDataTarifa`,
    // --TarifasClientes
    SelectAllDataTarifaClient: `${URL_API_InternaParametros}/?action=SelectAllDataTarifaClient`,
    InsertDataTarifaClient: `${URL_API_InternaParametros}/?action=InsertDataTarifaClient`,
    UpdateDataTarifaClient: `${URL_API_InternaParametros}/?action=UpdateDataTarifaClient`,
    DeleteDataTarifaClient: `${URL_API_InternaParametros}/?action=DeleteDataTarifaClient`,
    // --Obtener Tarifas por Convenio
    ObtenerDataTarifa: (CodConv) => `${URL_API_InternaParametros}/?action=ObtenerDataTarifa&CodConv=${CodConv}`,
  },
};
